import { Select, Button, Input, Modal } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ActivityProblemReportWrapper, ActivityReportSuccess } from './ReportProblem.styles';
import { getActivityReportOptions } from './utils';

import { Icon } from '@/components/Icon';
import { useReportProblemForm } from '@/hooks';
import { useActivityTrack } from '@/store';
const { Option } = Select;

export const ReportProblem = () => {
  const [selectedReportOption, setSelectedReportOption] = useState<string>();
  const [isOpenCommentArea, setIsOpenCommentArea] = useState(false);
  const { t } = useTranslation(['DefaultTranslations', 'StudentCourseTranslations']);
  const { sendActivityProblemReport, getCurrentActivity } = useActivityTrack();
  const { isOpen, closeForm } = useReportProblemForm();
  const [isCompleted, setIsCompleted] = useState(false);
  const [comment, setComment] = useState('');

  const isCommented = comment.length > 0;
  const { activity } = getCurrentActivity();

  if (!activity) return null;

  const options = getActivityReportOptions(activity.type, t);

  const handleSelectOption = (selectedOption: string) => {
    if (selectedOption === options[options.length - 1].key) {
      setIsOpenCommentArea(true);
      setSelectedReportOption(selectedOption);
    } else {
      setIsOpenCommentArea(false);
      setSelectedReportOption(selectedOption);
    }
  };

  const handleReset = () => {
    setSelectedReportOption(undefined);
    setComment('');
  };

  const handleCancel = () => {
    closeForm();
    setIsCompleted(false);
    handleReset();
  };

  const handleSubmitActivityReport = () => {
    if (!selectedReportOption) return;

    sendActivityProblemReport(
      {
        title: selectedReportOption,
        description: comment,
        activity: activity._id
      },
      () => {
        setIsCompleted(true);
        handleReset();
      }
    );
  };

  const isSendDisabled =
    !selectedReportOption ||
    (selectedReportOption === options[options.length - 1].key && !isCommented) ||
    (selectedReportOption !== options[options.length - 1].key && isCommented);

  return (
    <Modal centered open={isOpen} closable={true} onCancel={handleCancel} footer={null}>
      {!isCompleted ? (
        <ActivityProblemReportWrapper>
          <h4>{t('StudentCourseTranslations:ERROR_REPORT_MODAL_TITLE')}</h4>
          <div className="problem-selector">
            <span>{t('StudentCourseTranslations:PROBLEM_REPORT_SELECTOR_TITLE')}</span>
            <Select
              placeholder={t('StudentCourseTranslations:PROBLEM_SELECTOR_PLACEHOLDER')}
              onChange={handleSelectOption}
              value={selectedReportOption}>
              {options.map(option => (
                <Option key={option.key} value={option.key}>
                  {option.value}
                </Option>
              ))}
            </Select>
          </div>
          <div className="problem-description">
            <span>{t('StudentCourseTranslations:DESCRIPTION')}</span>
            <Input.TextArea
              value={comment}
              onChange={({ target: { value } }) => setComment(value)}
              rows={5}
              disabled={!isOpenCommentArea}
            />
          </div>
          <Button
            size="large"
            type="primary"
            disabled={isSendDisabled}
            onClick={handleSubmitActivityReport}>
            {t('StudentCourseTranslations:SEND_REVIEW')}
          </Button>
        </ActivityProblemReportWrapper>
      ) : (
        <ActivityReportSuccess>
          <Icon i="FaceSatisfied" />
          <span>{t('StudentCourseTranslations:PROBLEM_REPORT_THANK_YOU')}</span>
          <span>{t('StudentCourseTranslations:PROBLEM_REPORT_RECEIVED')}</span>
        </ActivityReportSuccess>
      )}
    </Modal>
  );
};
